import { PERMISSION_GROUPS, type OrganizationType, type PermissionScope } from "@bookdental/schemas";

export const SCOPE_LABELS: Record<PermissionScope, string> = {
  clinic: "Clínica",
  lab: "Laboratório",
  shared: "Geral",
};

const SCOPE_ORDER: PermissionScope[] = ["clinic", "lab", "shared"];

/** Quais áreas a matriz mostra pra essa organização. Sem tipo definido = mostra tudo (mesma
 *  semântica de "nenhum perfil, mostrando tudo" da Área de atuação). Esconder é só visual —
 *  defaults e overrides continuam resolvendo no servidor, e as features de laboratório já são
 *  barradas por tipo na API de qualquer jeito. */
export function escoposVisiveis(types: OrganizationType[]): Set<PermissionScope> {
  const semTipo = types.length === 0;
  const visiveis = new Set<PermissionScope>(["shared"]);
  if (semTipo || types.includes("DENTAL_OFFICE")) visiveis.add("clinic");
  if (semTipo || types.includes("DENTAL_LAB")) visiveis.add("lab");
  return visiveis;
}

/** Grupos de permissão organizados por área, já filtrados pro que a organização tem. */
export function gruposPorEscopo(types: OrganizationType[]) {
  const visiveis = escoposVisiveis(types);
  return SCOPE_ORDER.filter((scope) => visiveis.has(scope)).map((scope) => ({
    scope,
    label: SCOPE_LABELS[scope],
    groups: PERMISSION_GROUPS.filter((g) => g.scope === scope),
  }));
}

/** Aviso sobre a área oculta — pra ninguém achar que sumiu recurso. Null quando nada está oculto. */
export function avisoDeEscopoOculto(types: OrganizationType[]): string | null {
  const visiveis = escoposVisiveis(types);
  if (!visiveis.has("lab"))
    return "Permissões de laboratório aparecem quando a organização tem o perfil Laboratório — ative em Área de atuação.";
  if (!visiveis.has("clinic"))
    return "Permissões de clínica aparecem quando a organização tem o perfil Clínica — ative em Área de atuação.";
  return null;
}
